import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import TextLinkAnchor from '../TextLink/TextLinkAnchor';
import TextLinkButton from '../TextLink/TextLinkButton';
import TextLinkContent from '../TextLink/TextLinkContent';
const borderWidth = 1;
const horizontalPadding = 10;
const navigationalPillTextLinkContentStyles = css `
  align-self: center;
`;
const NavigationalPill = ({ disabled, download, href, icon, iconAlignment, modifier = 'primary', onClick, rel, size, submit, target, text, type, }) => {
    const navigationalPillContainerStyles = useMemo(() => css `
      align-items: center;
      border-radius: ${styleUtils.rem(100)};
      border-style: solid;
      border-width: ${styleUtils.rem(borderWidth)};
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      height: ${styleUtils.rem(40)};
      padding-bottom: ${styleUtils.rem(horizontalPadding)};
      padding-left: ${theme.spacing.x4};
      padding-right: ${theme.spacing.x4};
      padding-top: ${styleUtils.rem(horizontalPadding)};
      text-decoration: none;
      white-space: nowrap;
      width: fit-content;
      ${modifier === 'primary' && css `
        background-color: ${theme.colors.surfaceSystemPrimary};
        border-color: ${theme.colors.borderDefault};
        color: ${theme.colors.textPrimary};

        &:hover {
          background-color: ${theme.colors.surfaceSystemSecondary};
          border-color: ${theme.colors.borderHover};
          color: ${theme.colors.textPrimary};
          text-decoration: underline;
        }

        ${disabled && css `
          background-color: ${theme.colors.surfaceSystemPrimary};
          border-color: ${theme.colors.borderDisabled};
          color: ${theme.colors.textDisabled};
          cursor: default;

          &:hover,
          &:active,
          &:focus,
          &:visited {
            background-color: ${theme.colors.surfaceSystemPrimary};
            border-color: ${theme.colors.borderDisabled};
            color: ${theme.colors.textDisabled};
            text-decoration: none;

          }
        `}
      `}
      ${modifier === 'secondary' && css `
        background-color: ${theme.colors.accent700};
        border-color: ${theme.colors.accent700};
        color: ${theme.colors.gray100};

        &:hover {
          background-color: ${theme.colors.accent800};
          border-color: ${theme.colors.accent800};
          color: ${theme.colors.gray100};
          text-decoration: underline;
        }

        ${disabled && css `
          background-color: ${theme.colors.surfaceSystemDisabled};
          border-color: ${theme.colors.borderDisabled};
          color: ${theme.colors.textDisabled};
          cursor: default;

          &:disabled,
          &:hover,
          &:active,
          &:focus,
          &:visited {
            background-color: ${theme.colors.surfaceSystemDisabled};
            border-color: ${theme.colors.borderDisabled};
            color: ${theme.colors.textDisabled};
            text-decoration: none;
          }
        `}
      `}
    `, [
        disabled,
        modifier,
    ]);
    return (href
        ? (_jsx(TextLinkAnchor, Object.assign({ css: navigationalPillContainerStyles, disabled: disabled, download: download, href: href, rel: rel, target: target }, { children: _jsx(TextLinkContent, { css: navigationalPillTextLinkContentStyles, disabled: disabled, icon: icon, iconAlignment: iconAlignment, size: size, text: text !== null && text !== void 0 ? text : '', type: type }) })))
        : (_jsx(TextLinkButton, Object.assign({ css: navigationalPillContainerStyles, disabled: disabled, onClick: onClick ? onClick : () => { }, submit: submit }, { children: _jsx(TextLinkContent, { css: navigationalPillTextLinkContentStyles, disabled: disabled, icon: icon, iconAlignment: iconAlignment, size: size, text: text !== null && text !== void 0 ? text : '', type: type }) }))));
};
const MemoizedNavigationalPill = memo(NavigationalPill);
export { MemoizedNavigationalPill as NavigationalPill };
// MC-1068 Temporary hack for Storybook.
export default MemoizedNavigationalPill;
